// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_1Sb8o","visuallyhidden":"_1kwP3","hide-text":"_1Qg5b","center":"_2BtOj","noprint":"_15Ca9","articlesList":"_1cRzt","listItem":"_1SBVB","article":"_2FCBm","articleLink":"_3vknC","root":"_3vZ1g"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-article-list/styles/sports.scss
 ** module id = 342
 ** module chunks = 2
 **/